import moment from "moment";

export const mixins = {
  // Date Formatter
  formatDate(date) {
    return moment(date).format("MMM Do YYYY, hh:mm a");
  },
  calculateProgress(val1, val2) {
    return [Math.round((val1 / val2) * 100) || 0];
  },
  estimate(val){
    return val.replace(/d|m|h/gi, function(x){
      return x+" ";
    })
  },
  formateDateToMilliSeconds(date) {
    return moment(date).valueOf();
  },
};
